import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-error',
  templateUrl: './dialog-error.component.html'
})
export class DialogErrorComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
